import { jsx as _jsx } from "react/jsx-runtime";
import GalleryLayout from "./containers/gallery-layout";
import styles from "./styles.css";
import { UserGeneratedContentProvider } from "./context/user-generated-content";
import { ugcReducer } from "./state/user-generated-content/reducer";
import { LocaleProvider } from "./context/locale-provider";
export default function App({ contentData, storeData, countPerPage, categoryId }) {
    return (_jsx("div", { className: styles.container, children: _jsx(LocaleProvider, { languageStrings: storeData?.languageStrings, children: _jsx(UserGeneratedContentProvider, { initialState: {
                    contentList: contentData?.media ?? [],
                    pagination: contentData?.cursor || {},
                }, reducer: ugcReducer, children: _jsx(GalleryLayout, { countPerPage: countPerPage, categoryId: categoryId }) }) }) }));
}
